import { BottomNavButton } from "@/components/ui/navigation/BottomNavButton"
import { NAV_ITEMS, type BadgeState } from "@/lib/navigationItems"
import { useUnreadChatsCount } from '@/hooks/useUnreadChatsCount';
import { isNative } from '@/lib/platform';

// Define the order of items for the Booking System Dashboard bottom nav
const BOOKING_DASHBOARD_BOTTOM_NAV_ITEMS = [
  NAV_ITEMS.CALENDAR,
  NAV_ITEMS.DASHBOARD,
  NAV_ITEMS.AVAILABILITY,
];

export function BookingSystemDashboardBottomNav() {
  const { count: unreadCount } = useUnreadChatsCount();

  // Build badge state
  const badgeState: BadgeState = {
    unreadCount,
    isNative: isNative(),
  };

  return (
    <div className="bottom-nav-container bottom-nav flex items-center justify-around">
      {BOOKING_DASHBOARD_BOTTOM_NAV_ITEMS.map((item) => (
        <BottomNavButton
          key={item.id}
          item={item}
          badgeState={badgeState}
          labelOverride={
            item.id === 'calendar' ? 'Calendar' : 
            item.id === 'dashboard' ? 'Dashboard' : 
            item.id === 'availability' ? 'Availability' : 
            undefined
          }
        />
      ))}
    </div>
  )
}
